import { ILocale, ILocalizable } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { IValidationIssue } from "infrastructure/validation";
import { IIndustry, IApiError } from "ui/shared/models/common";

import { ITokenItem } from "../shared/types/Token.types";

export interface IPlexTranslationMessagesManagerState {
  filter: IPlexTranslationMessagesManagerFilter;
  actionBar: IPlexTranslationMessagesManagerActionBar;
  grid: IPlexTranslationMessagesManagerGrid;
  notifications: INotification[];
  isLoading: boolean;
  isExportDisabled: boolean;
}

export interface IPlexTranslationMessageItem {
  locale?: string;
  industry?: string;
  messageId: string;
  sourceText: string;
  translatedText?: string;
  tokens: ITokenItem[];
  textPreview: string;
  translationStatus: string;
  version: number;
  isParentMessage?: boolean;
  assignedTo?: string;
}

export interface IPlexTranslationMessagesManagerActionBar {
  accountPickerData: IAccount[];
  accountSelected?: IAccount;
  notifications: INotification[];
  review?: IReviewPlexTranslationMessages;
}
export class IReviewPlexTranslationMessages {
  comment?: string;
}

export interface IPlexTranslationMessagesManagerFilter {
  locales: ILocale[];
  supportedLocales?: ILocale[];
  industries: IIndustry[];
  assignedToAccounts: IAccount[];
  text?: string | null;
  messageId?: string | null;
  statuses: ILocalizable[];
  parents: ILocalizable[];
  isCheckedShowPreviewText: boolean;
  lastData?: IPlexTranslationMessagesManagerFilterData;
}

export interface IPlexTranslationMessagesManagerFilterData {
  selectedLocale?: ILocale;
  selectedIndustry?: IIndustry;
  selectedAssignedTo?: IAccount;
  filterText?: string;
  filterMessageId?: string;
  selectedStatus?: ILocalizable;
  selectedParent?: ILocalizable;
  isCheckedShowPreviewText?: boolean;
}

export interface IPlexTranslationMessageRow {
  data: IPlexTranslationMessageItem;
  originalData?: IPlexTranslationMessageItem;
  isTranslationChanged: boolean;
  index: number;
  validationIssues: IValidationIssue[];
}

export interface IPlexTranslationMessagesManagerGrid {
  gridData: IPlexTranslationMessageRow[];
  selected: IPlexTranslationMessageRow[];
  isSearched: boolean;
}

export interface IChangeText {
  index: number;
  text?: string;
}

export interface IPlexTranslationMessageModifyData {
  isTranslationChanged: boolean;
  index: number;
  translatedText?: string;
  originalData?: IPlexTranslationMessageItem;
  messageId: string;
  validationIssues: IValidationIssue[];
}

export interface IPlexTranslationErrorModel {
  messageId: string;
  error: IApiError;
}

export interface IAccount {
  accountId: string;
  name: string;
}

export interface IButtonDisabled {
  isRequestDisabled: boolean;
  isReassignDisabled: boolean;
  isProposedDisabled: boolean;
  isReviewDisabled: boolean;
  isApproveDisabled: boolean;
  isRejectDisabled: boolean;
  isObsoleteDisabled: boolean;
}

export const getInitialPlexTranslationMessagesManagerState = (): IPlexTranslationMessagesManagerState => ({
  filter: {
    locales: [],
    supportedLocales: [],
    industries: [],
    text: "",
    messageId: "",
    statuses: [],
    assignedToAccounts: [],
    parents: [],
    isCheckedShowPreviewText: false
  },
  actionBar: { accountPickerData: [], notifications: [] },
  grid: { gridData: [], selected: [], isSearched: false },
  isExportDisabled: true,
  notifications: [],
  isLoading: false
});

export type SelectorState = { plexTranslationMessagesManager: IPlexTranslationMessagesManagerState };

const getStateSelectorsProvider = () => ({
  getFilter: (state: SelectorState) => state.plexTranslationMessagesManager.filter,
  getFilterLastData: (state: SelectorState) => state.plexTranslationMessagesManager.filter.lastData,
  getGridRows: (state: SelectorState) => state.plexTranslationMessagesManager.grid.gridData,
  getNotifications: (state: SelectorState) => state.plexTranslationMessagesManager.notifications
});

export const selectors = getStateSelectorsProvider();
